module.exports = __webpack_public_path__ + "assets/img/defaultAvatar.37c3ea6b.png";